import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './index.scss';
import AppWithAuth from './AppWithAuth';
import 'jquery/dist/jquery'
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Home from './home';

ReactDOM.render(
    <React.StrictMode>
        <Home />
    </React.StrictMode>,
    document.getElementById('root')
);